import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="popup">
      <div className="loader"></div>
    </div>
  );
};
export default Loading;
